import API from '../../utils/api';
import * as types from './types';
import { defaultLocale } from '../../utils/translation';
import LocalStorage from '../../utils/localStorage';
import { ENDPOINT_URL } from '../../constants/defaultValues';

export const getSeasons = ({ sportTypeId, startDate, endDate, pageNumber }) => async dispatch => {
    dispatch({ type: types.GET_SEASONS_REQUEST });
    const lang = LocalStorage.getItem('lang') || defaultLocale;
    await API.get(`${ENDPOINT_URL}/seasons/archive?pageIndex=${pageNumber}`, {
        headers: { 'x-lang': lang },
        params: {
            sportTypeId,
            startDate,
            endDate,
        },
    })
        .then(res => {
            const { info, item } = res.data;
            if (info.success) {
                dispatch({
                    type: types.GET_SEASONS_SUCCESS,
                    payload: item,
                });
            }
        })
        .catch(err => console.log({ err }));
};
